import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "../lib/api";

const abs = (u) => (u || "").startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;
const DISMISS_KEY = "icaard_sponsored_dismissed";

/** Sponsored banner — 16:9 media so users can actually SEE the advert. */
export default function SponsoredCard() {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    try {
      const until = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
      if (until > Date.now()) { setHidden(true); return; }
    } catch (_) {}
    api.get("/ads/active").then((r) => setAds(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (ads.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % ads.length), 8000);
    return () => clearInterval(t);
  }, [ads.length]);

  if (hidden || !ads.length) return null;
  const ad = ads[idx];

  const dismiss = (e) => {
    e.stopPropagation();
    localStorage.setItem(DISMISS_KEY, String(Date.now() + 24 * 3600 * 1000));
    setHidden(true);
  };
  const open = () => {
    api.post(`/admin/ads/${ad.id}/click`).catch(() => {});
    if (ad.target_url) window.open(ad.target_url, "_blank", "noopener");
  };

  return (
    <div onClick={open} data-testid="sponsored-card"
         className="relative surface rounded-2xl overflow-hidden cursor-pointer group">
      {/* 16:9 media */}
      <div className="aspect-video w-full bg-[#1A1A27]">
        {ad.media_url ? (
          ad.media_type === "video"
            ? <video src={abs(ad.media_url)} autoPlay muted loop playsInline className="w-full h-full object-cover" />
            : <img src={abs(ad.media_url)} alt={ad.title} className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center font-display font-black text-3xl text-white/20">{ad.title?.[0]}</div>
        )}
      </div>
      {/* gradient caption */}
      <div className="absolute inset-x-0 bottom-0 p-3 sm:p-4 pt-10 bg-gradient-to-t from-black/90 via-black/50 to-transparent">
        <div className="text-[8px] uppercase tracking-[0.3em] font-black text-[#F5B400]">Sponsored</div>
        <div className="text-sm sm:text-base font-bold text-white truncate">{ad.title}</div>
        {ad.description && <div className="text-[11px] text-[#D9D9E6] line-clamp-2">{ad.description}</div>}
        {ad.target_url && <span className="text-[11px] font-bold text-[#A78BFA]">Learn more →</span>}
      </div>
      <button onClick={dismiss} data-testid="sponsored-dismiss" aria-label="Dismiss ad"
              className="absolute top-2 right-2 p-1.5 rounded-full bg-black/50 text-white/70 hover:text-white hover:bg-black/70">
        <X size={13} />
      </button>
    </div>
  );
}
